import styled from '@emotion/styled';
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@material-ui/lab';
import React from 'react';

const ToggleButtonGroupPillsBase = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-root': {
    borderRadius: '20px',
  },
  '& .MuiToggleButton-root': {
    borderRadius: '20px !important',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    padding: '4px 16px',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    minWidth: '48px',
    height: '32px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    '&:not(.Mui-selected):hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    '&:first-of-type': {
      borderTopRightRadius: '4px !important',
      borderBottomRightRadius: '4px !important',
      marginRight: '-1px',
    },
    '&:last-of-type': {
      borderTopLeftRadius: '4px !important',
      borderBottomLeftRadius: '4px !important',
    },
  },
}));

export interface ToggleOption {
  value: string | number;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface StyledToggleButtonGroupProps extends Omit<ToggleButtonGroupProps, 'children'> {
  options: ToggleOption[];
  className?: string;
  'data-testid'?: string;
}

/**
 * A generic styled toggle button group component that wraps Material-UI's ToggleButtonGroup
 * with consistent custom styling. Can be used for any toggle functionality.
 */
export const ToggleButtonGroupPills: React.FC<StyledToggleButtonGroupProps> = ({
  options,
  className,
  'data-testid': testId,
  ...toggleButtonGroupProps
}) => {
  return (
    <ToggleButtonGroupPillsBase
      className={className}
      data-testid={testId}
      {...toggleButtonGroupProps}
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroupPillsBase>
  );
};

export { ToggleButtonGroupPillsBase };
